import axios from "axios";
import { DOMAIN } from "../constants";
import httpService from "./request";
import { getUserEmail } from "./index";
import { isMobile as isMobile1 } from "react-device-detect";

const API_URL = `${DOMAIN}/api`;

// Create an instance of axios
const api = axios.create({
  baseURL: API_URL, // Replace with your API base URL
  timeout: 20000, // Set a timeout (optional)
  headers: {
    "Content-Type": "application/json",
    // Add any other headers you need
  },
  withCredentials: true,
});

// Interceptors can be added here if needed
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token && config.url.includes("private")) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    // You can add authorization tokens or modify the config here
    return config;
  },
  (error) => {
    // Handle the request error here
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    // You can modify the response data here if needed
    return response.data;
  },
  async (error) => {
    if (error?.response?.status === 401) {
      const response = await httpService.post(`/auth/logout`, {
        username: getUserEmail(),
        deviceType: isMobile1 ? "mobile" : "web",
      });
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    // Handle response errors here
    return Promise.reject(error);
  }
);

export default api;
